<template>
  <span>
    <font-awesome-icon :id="tooltipId"
                       class=""
                       :icon="icon">
    </font-awesome-icon>
    <b-tooltip :target="tooltipId"
               custom-class="info-popup"
               position="topright"
    >
      {{ value }}
    </b-tooltip>
  </span>
</template>

<script>
export default {
  name: "InfoPopup",
  props: {
    icon: {
      type: Array,
      default: () => ['far', 'info-circle'],
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    tooltipId() {
      return 'tooltip-' + Math.floor(Math.random() * (999999 - 1)) + 1;
    },
  },
}
</script>

<style lang="scss">
.info-popup {
  opacity: 1 !important;
  .tooltip-inner {
    background: #FFF;
    color: #2C3E38;
    font-size: 0.7rem;
    line-height: 0.9rem;
    border: 1px solid #E5ECF0;
  }
  .arrow {
    &:before {
      border-top-color: #FFF;
    }
  }
}
</style>
